import { add, isBefore } from 'date-fns';
import { removeDuplicateProducts } from 'bento-ordering/menus/selectors';
import { shuffle } from 'bento-ordering/utils/arrayUtils';
import { CUSTOM_ITEMS } from 'bento-ordering/cart/constants/upsellTypes';

export const updateQuantityToMin = (form, minimum_quantity) => {
  form.change('quantity', minimum_quantity);
};

export const getMenuItemsFromSections = menu => {
  if (!menu || !Array.isArray(menu.sections)) {
    return [];
  }

  const menuItems = [];
  const recursiveFlatten = items => {
    for (const section of items) {
      if (Array.isArray(section.items)) {
        menuItems.push(...section.items);
      }
      if (Array.isArray(section.sections)) {
        recursiveFlatten(section.sections);
      }
    }
  };

  recursiveFlatten(menu.sections);
  return removeDuplicateProducts(menuItems);
};

export const isUpsellItemAvailableWithLeadTime = (
  item,
  cartFulfillmentMoment
) => {
  const { lead_time_days: days, lead_time_hours: hours } = item.product;
  const currentDate = new Date();
  const futureDateTime = add(currentDate, {
    days,
    hours
  });

  return isBefore(futureDateTime, cartFulfillmentMoment);
};

export const getMenuUpsellItemsNotInCartWithAcceptableLeadTimes = (
  cartItems,
  menuItems,
  upsellItemIds,
  upsellType,
  cartFulfillmentTime
) => {
  const upsellItems = menuItems.filter(
    item =>
      item.inventory !== 0 &&
      upsellItemIds.includes(item.product.id) &&
      !cartItems.includes(item.product.id) &&
      isUpsellItemAvailableWithLeadTime(item, cartFulfillmentTime)
  );

  const returnItems =
    upsellType === CUSTOM_ITEMS
      ? shuffle(upsellItems).slice(0, 3)
      : upsellItems.slice(0, 3);

  return returnItems;
};

export const formatMenuWithModifiers = (
  menu,
  menuItemsModifierAndOptionNames
) => {
  return {
    ...menu,
    sections: (menu?.sections || []).map(section => ({
      ...section,
      items: section.items.map(item => ({
        ...item,
        modifierAndOptionNames:
          menuItemsModifierAndOptionNames[item.product.id] || []
      }))
    }))
  };
};
